<template>
  <div id="system-journal-setting-article-type-setting">
    <div class="ipub-filter-div mar-b-20">
      <ipub-row :gutter="[12,16]">
        <ipub-col :span="12">
          <site-search-group v-model.trim="params.keyword"
                             placeholder="Search by option name / other name"
                             @search="getList()"
                             @clear="handleClear" />
        </ipub-col>
      </ipub-row>
    </div>
    <div>
      <ipub-table :columns="columns"
                  fixed
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:time="{text,record}">
          <span v-if="text">{{ text?$moment(text).format('HH:mm  DD / MM / YYYY'): '- -' }}</span>
          <span v-else>{{$moment(record.createTime).format('HH:mm  DD / MM / YYYY')}}</span>
        </template>
        <template v-slot:email="{text}">
          {{text && text.email || '--'}}
        </template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes('SYSTEM.PUBLISHER_SETTING.COUNTRY_SETTING.EDIT')">
            <div slot="title">Edit</div>
            <ipub-icon type="iconEdit"
                       @click="edit(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <add-dialog :isVisable="isVisable"
                :inputData="inputData"
                @cancel="cancel"
                @confirm="confirm">

    </add-dialog>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
